import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { isNeuropsychEvaluationProgram } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'

import { ROLES } from '../../../../../common/constants/appConstants'
import { hasRole } from '../../../../../common/utils/utils'
import { getAuthRoles, getAuthSupervisorRoles } from '../../../../../data/auth/authSelectors'
import { useSelectedEpisodeForClient } from '../../../../episodes/data/hooks/useSelectedEpisodeForClient'

export const useCanManageCareTeam = (): boolean => {
  const { isNPTestingEnabled } = useFlags()
  const roles = useSelector(getAuthRoles)
  const supervisorRoles = useSelector(getAuthSupervisorRoles)
  const { data: selectedEpisode } = useSelectedEpisodeForClient()

  const isNpSupervisor =
    hasRole(roles, ROLES.NPTESTER_SUPERVISOR) || hasRole(supervisorRoles, ROLES.NPTESTER_SUPERVISOR)

  return Boolean(isNPTestingEnabled && isNeuropsychEvaluationProgram(selectedEpisode?.program_name) && isNpSupervisor)
}
